<span [style]="'width:' + progress + '%'" class="progress"></span>
